import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import { Sidebar } from "primereact/sidebar";
import exportimages from "../../../../../../assets/images/exportImages";
import { useDispatch, useSelector } from "react-redux";
import "./InsightsAndRecommendation.scss";
import parse from "html-react-parser";
import {
  EWI_CONFIG,
  EWI_Image_array,
  EWI_LOCK_SCREEN_DATA,
  HASHTAGKEYARRAY,
  SUBSCRIPTION,
} from "../../../../../../utils/global";
import {
  useGetInsightsAndRecommendationQuery,
  useQueryStateInsightsAndRecommendation,
} from "../../../../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import zIndex from "@mui/material/styles/zIndex";
import { ImageAndDataPopUp } from "../../../../../Common/Popup/ImageAndDataPopUp/ImageAndDataPopUp";
import {
  insightsAndStrategyData,
  UpgradeToAutopilotProfit,
} from "../../../../../Common/Popup/ImageAndDataPopUp/DataContent";
import DownloadFHSReportButton from "../../CustomHooks/DownloadFHSReportButton";
import { breadcrumHistory } from "../../../../../../Redux/navigationHistorySlice";
import DOMPurify from "dompurify";
import { useSubscription } from "../../../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../../../utils/privileges";
import { Chatbot } from "../../../../../Common/Chatbot/Chatbot";

const InsightsAndRecommendation = () => {
  const { hasSubscription } = useSubscription();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const orgReducer = useSelector((state) => state?.orgReducer);
  const authReducer = useSelector((state) => state.authReducer);
  const [visibleRight, setVisibleRight] = useState(false);
  const [insightsModal, setInsightsModal] = useState(false);
  const [autopilotProfitModal, setAutopilotProfitModal] = useState(false);
  const [selectedCardData, setSelectedcardData] = useState();
  const selectedBankData = useSelector(
    (state) => state?.infiniteBankPerformanceMetricsReducer,
  );

  const [earlyWarningIndicators, setEarlyWarningIndicators] = useState([]);

  useEffect(() => {
    setEarlyWarningIndicators(
      selectedBankData?.selectedBankMetricData?.early_warning_indicators,
    );
  }, [selectedBankData]);

  useEffect(() => {
    if (
      earlyWarningIndicators?.length > 0 &&
      earlyWarningIndicators?.length <= 3
    ) {
      const fetchCarousalLink = document.querySelectorAll(
        "#InsightsAndRecommendation .p-link",
      );
      fetchCarousalLink.forEach((el) => {
        el.classList.add("d-none");
      });
    }
  }, [earlyWarningIndicators]);

  const insightsCardClick = (key, cardData, mainResponseData) => {
    setVisibleRight(true);

    // Find the matching full data using title_name or key
    const matchedInsight = mainResponseData.find(
      (item) => item.title_name === cardData.title_name,
    );

    if (!matchedInsight) return;

    const { rationale, problem, detailed_action_plan } = matchedInsight;

    const obj = {
      cardImage:
        EWI_Image_array[cardData.index]?.EWI_icon ||
        exportimages?.EWI_Default_img,
      cardHeader: matchedInsight?.title_name,
      key: key,
      data: [
        {
          label: "Problem",
          img: exportimages?.insights_icon_problem,
          content: Array.isArray(problem) ? problem.join("\n\n") : problem,
        },
        {
          label: "Consequence",
          img: exportimages?.insights_icon_rational,
          content: Array.isArray(rationale)
            ? rationale.join("\n\n")
            : rationale,
        },

        {
          label: "Short-Term (0–6 Months)",
          img: exportimages?.insights_icon_shortterm,
          content: detailed_action_plan?.short_term?.join("\n\n"),
        },
        {
          label: "Mid-Term (6–12 Months)",
          img: exportimages?.insights_icon_midterm,
          content: detailed_action_plan?.mid_term?.join("\n\n"),
        },
        {
          label: "Long-Term (12+ Months)",
          img: exportimages?.insights_icon_longterm,
          content: detailed_action_plan?.long_term?.join("\n\n"),
        },
      ],
    };

    setSelectedcardData(obj);
  };

  const ewiFormating = (text) => {
    const isPro = authReducer?.userData?.subscription === SUBSCRIPTION.PRO;
    return (
      text
        // Split by either #hashtag or "Empirical support:" (case-insensitive)
        .split(/(#\w+|Empirical support:)/gi)
        .map((part, index) => {
          if (!part) return null;

          // 🔹 Case 1: Hashtag detected

          if (/^#\w+/.test(part)) {
            const word = part.slice(1);

            // Find matching entry from common array
            const matched = HASHTAGKEYARRAY.find((item) => item.key === word);

            const url = matched
              ? matched.url(orgReducer?.healthAnalysisID?.uid)
              : "#";

            return isPro ? (
              <a
                key={`hash-${index}`}
                href={url}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    breadcrumHistory({
                      cardName: "",
                      currentPath: location.pathname,
                      checkPathFromCluster: false,
                      checkPathFromEWI: true,
                      checkEWIClickedID: word,
                      hid: "",
                    }),
                  );
                }}
              >
                {part}
              </a>
            ) : (
              part.replace("#", "")
            );
          }

          // 🔹 Case 2: "Empirical support:" detected (case-insensitive)
          if (/^Empirical support:$/i.test(part.trim())) {
            return <strong key={`emp-${index}`}>{part}</strong>;
          }

          // 🔹 Case 3: Replace **<context>** with <strong> tag
          const result = part.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

          // 🔹 Case 4: Plain text
          const safeHTML = DOMPurify.sanitize(result);

          return (
            <span
              key={`txt-${index}`}
              dangerouslySetInnerHTML={{
                __html: safeHTML,
              }}
            />
          );
        })
    );
  };

  const earlyWarningIndicator = (
    key,
    data,
    main_header,
    mainResponseData,
    isPlaceholder,
  ) => {
    const lowerKey = key?.toLowerCase();

    const renderSection = (
      sectionImg,
      label,
      content,
      bgClass = "",
      isPlaceholder,
    ) => {
      if (!content) return null;

      return (
        <>
          <div
            className={
              isPlaceholder
                ? `insights-card-details subscription-card-details ${bgClass}`
                : `insights-card-details ${bgClass}`
            }
          >
            <label
              style={{
                display: label ? "flex" : "none",
                cursor: label && !isPlaceholder ? "pointer" : "default",
                marginBottom: "1.231rem",
                alignItems: "center",
              }}
              className={
                label === "Recommendation" ||
                  label === "Expected Outcome with Autopilot"
                  ? "bg-blue-label-block"
                  : ""
              }
            >
              <img
                src={sectionImg}
                alt="insights_icon_2"
                style={{
                  marginRight: "1.077rem",
                  flexShrink: 0,
                  alignSelf: "flex-start",
                }}
              />
              <span
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  flex: 1,
                  lineHeight: "1.4",
                }}
              >
                {label}
              </span>
            </label>
            <div className="insights-card-details-desc">
              <ul
                className={isPlaceholder ? "d-none" : "d-block"}
                style={{ paddingLeft: 0 }}
              >
                {(() => {
                  const lines = String(content).split(/(?=- )/);

                  const sanitizedLines = lines?.filter((i) => {
                    return i !== "";
                  });

                  return sanitizedLines?.map((line, index) => {
                    const trimmed = line.replace("</br>", "").trim();
                    const isBullet = trimmed.startsWith("- ");
                    const content = isBullet
                      ? trimmed.slice(1).trim()
                      : trimmed;

                    const linked = ewiFormating(content);

                    return (
                      <li
                        key={index}
                        style={{
                          listStyleType: isBullet ? "disc" : "none",
                          marginLeft: isBullet ? "20px" : "0",
                        }}
                      >
                        {linked}
                      </li>
                    );
                  });
                })()}
              </ul>

              <div
                className={
                  !isPlaceholder ? "d-none" : "d-flex ewi_subscription_block"
                }
              >
                <img
                  src={content.img}
                  className={content.img ? "d-block mx-auto" : "d-none"}
                />
                <label>{content.title}</label>
                <p className="mb-0">{content.content}</p>
                <button
                  style={{ pointerEvents: "auto", zIndex: 1 }}
                  className={content.buttonLabel ? "d-block" : "d-none"}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/user/pricingTable`);

                    setVisibleRight(false);
                  }}
                >
                  {content.buttonLabel}{" "}
                  <img
                    src={exportimages?.EWI_arrow_right}
                    style={{
                      height: "1.846rem",
                      width: "1.846rem",
                      marginBottom: 0,
                      verticalAlign: "middle",
                      marginLeft: "0.615rem",
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </>
      );
    };

    return (
      <div
        style={{
          pointerEvents: !isPlaceholder ? "pointer" : "none",
        }}
        className={
          lowerKey === "early_warning_indicators"
            ? "insights-card"
            : "insights-card cursor-pointer"
        }
        onClick={() => insightsCardClick(main_header, data, mainResponseData)}
      >
        <div style={{ cursor: "pointer" }}>
          <div
            className={
              isPlaceholder
                ? "d-none"
                : "d-flex justify-content-start ewi-label mb-4"
            }
          >
            <div>
              <div className="insights-card-img d-flex">
                <img
                  src={data.icon_name}
                  alt={data.title_name}
                  className="me-4"
                />
                <p
                  className={
                    lowerKey === "early_warning_indicators"
                      ? "insights-card-label"
                      : "insights-card-label cursor-pointer"
                  }
                >
                  {parse(String(data.title_name || ""))}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Early Warning Indicator: show Rationale */}
        {lowerKey === "early_warning_indicators" &&
          !isPlaceholder &&
          renderSection(
            exportimages?.insights_icon_problem,
            "Problem",
            data.content.problem_summary,
            "ewi-problem",
            isPlaceholder,
          )}
        {lowerKey === "early_warning_indicators" &&
          !isPlaceholder &&
          renderSection(
            exportimages?.insights_icon_rational,
            "Consequence",
            data.content.rationale_summary,
            "ewi-consequence",
            isPlaceholder,
          )}
        {lowerKey === "early_warning_indicators" &&
          !isPlaceholder &&
          renderSection(
            exportimages?.insights_icon_recommendation_new,
            "Recommendation",
            data.content.recommendation,
            "ewi-recommendation",
            isPlaceholder,
          )}
        {lowerKey === "early_warning_indicators" &&
          !isPlaceholder &&
          renderSection(
            exportimages?.insights_icon_recommendation_new,
            "Expected Outcome with Autopilot",
            data.content.expected_outcome,
            "ewi-expectedOutcome",
            isPlaceholder,
          )}

        {lowerKey === "early_warning_indicators" &&
          isPlaceholder &&
          renderSection(
            "",
            "",
            EWI_LOCK_SCREEN_DATA[0],
            "bg-insights-card",
            "ewi-lock-screen-1",
            isPlaceholder,
          )}
        {lowerKey === "early_warning_indicators" &&
          isPlaceholder &&
          renderSection(
            "",
            "",
            EWI_LOCK_SCREEN_DATA[1],
            "ewi-lock-screen-2",
            isPlaceholder,
          )}
      </div>
    );
  };

  const customHeader = (
    <label className="insights-detail-view-title">
      {selectedCardData?.key}
    </label>
  );

  useEffect(() => {
    setTimeout(() => {
      const ewi_title = document.querySelectorAll(".ewi-label");
      let maxTitleHeight = 0;
      ewi_title.forEach((el) => {
        if (el.scrollHeight > maxTitleHeight) {
          maxTitleHeight = el.scrollHeight;
        }
      });
      ewi_title.forEach((el) => (el.style.height = maxTitleHeight + "px"));

      const ewi_problem = document.querySelectorAll(".ewi-problem");
      let maxProblemHeight = 0;
      ewi_problem.forEach((el) => {
        if (el.scrollHeight > maxProblemHeight) {
          maxProblemHeight = el.scrollHeight;
        }
      });
      ewi_problem.forEach((el) => (el.style.height = maxProblemHeight + "px"));

      const ewi_consequence = document.querySelectorAll(".ewi-consequence");
      let maxConsequenceHeight = 0;
      ewi_consequence.forEach((el) => {
        if (el.scrollHeight > maxConsequenceHeight) {
          maxConsequenceHeight = el.scrollHeight;
        }
      });
      ewi_consequence.forEach(
        (el) => (el.style.height = maxConsequenceHeight + "px"),
      );

      const ewi_expectedOutcome = document.querySelectorAll(
        ".ewi-expectedOutcome",
      );
      let maxexpectedOutcomeHeight = 0;
      ewi_expectedOutcome.forEach((el) => {
        if (el.scrollHeight > maxexpectedOutcomeHeight) {
          maxexpectedOutcomeHeight = el.scrollHeight;
        }
      });
      ewi_expectedOutcome.forEach(
        (el) => (el.style.height = maxexpectedOutcomeHeight + "px"),
      );

      const ewi_recommendation = document.querySelectorAll(
        ".ewi-recommendation",
      );
      let maxRecommendationHeight = 0;
      ewi_recommendation.forEach((el) => {
        if (el.scrollHeight > maxRecommendationHeight) {
          maxRecommendationHeight = el.scrollHeight;
        }
      });
      ewi_recommendation.forEach(
        (el) => (el.style.height = maxRecommendationHeight + "px"),
      );

      // Sum of both max heights
      const totalHeight = maxTitleHeight + maxProblemHeight;
      const totalHeightforLockedAutopilot =
        maxConsequenceHeight + maxRecommendationHeight;

      // Apply to ewi-lock-screen-1
      const lockScreen = document.querySelectorAll(".ewi-lock-screen-1");
      if (lockScreen.length > 0) {
        lockScreen.forEach((el) => (el.style.height = totalHeight + 13 + "px"));
      }

      // Apply to ewi-lock-screen-2
      const lockScreen2 = document.querySelectorAll(".ewi-lock-screen-2");
      if (lockScreen2.length > 0) {
        lockScreen2.forEach(
          (el) => (el.style.height = totalHeightforLockedAutopilot + 24 + "px"),
        );
      }
    }, 1000);
  }, [earlyWarningIndicators]);

  return (
    <div
      className="dashboardContainer position-relative"
      id="InsightsAndRecommendation"
    >
      <div className="row g-0 p-4 py-2 pdf-visiblity">
        <div className="col-md-6 col-sm-12">
          <div className="custom-theme pageTitle">
            <h3 className="text-dark fs-page-title fw-bolder lh-lg mb-0">
              EWI & Strategies
            </h3>
          </div>
          <div className="text-868687 fs-breadcrumbs">
            <span>
              <span>
                {authReducer?.userData?.subscription === SUBSCRIPTION.ANALYST
                  ? <span className="fs-breadcrumbs ms-1">Dashboard</span>
                  : <Link
                    id="dashboard_link_to_cohort"
                    to={`/bank/health-analysis/report/${orgReducer?.healthAnalysisID?.uid
                      ? orgReducer?.healthAnalysisID?.uid
                      : "no-analysis-id"
                      }`}
                    style={{ color: "#868687" }}
                  >
                    <span className="fs-breadcrumbs ms-1">Dashboard</span>
                  </Link>}
              </span>
              {" > "}
            </span>
            <span>
              <span>
                <Link
                  id="graph_link_to_report"
                  onClick={() => navigate(-1)}
                  style={{ color: "#868687" }}
                >
                  {/* Financial Health */}
                  Financial Performance Benchmark
                </Link>
              </span>
              {" > "}
            </span>
            <span className="text-4b4b4b text-decoration-underline">
              EWI & Strategies
            </span>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 text-end align-content-center">
          <button
            type="button"
            id="kt_login_password_reset_form_cancel_button"
            style={{ marginRight: "0.923rem" }}
            onClick={() => {
              navigate(-1);
            }}
            className="btn btn-outline-primary border-primary btn-bond"
          >
            <img
              alt="back-arrow"
              src={exportimages?.backArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImage"
            />
            <img
              alt="back-arrow"
              src={exportimages?.hoverBackArrowNew}
              className="w-5px me-2 align-baseline img-fluid arrowImageHover"
            />
            <span className="fs-btn-text fw-normal">Back</span>
          </button>

          <button
            type="button"
            id="kt_login_password_reset_form_cancel_button"
            onClick={(e) => setAutopilotProfitModal(true)}
            className="btn btn-other btn-bond"
            style={{
              backgroundColor: "#6c7de5",
              color: "#fff",
              display:
                authReducer?.userData?.subscription === SUBSCRIPTION.ANALYST
                  ? "d-inline-block"
                  : "none",
            }}
          >
            <span className="fs-btn-text fw-normal">
              Upgrade to Autopilot Profit
            </span>
          </button>
        </div>
      </div>

      <div className="row g-0 p-4">
        {earlyWarningIndicators && earlyWarningIndicators.length > 0 ? (
          <>
            {EWI_CONFIG.map((config) => {
              const groupedDataMap = {};

              earlyWarningIndicators.forEach((item, index) => {
                const title = item.title_name;
                if (!groupedDataMap[title]) {
                  groupedDataMap[title] = {
                    icon_name:
                      EWI_Image_array[index]?.EWI_icon ||
                      exportimages?.EWI_Default_img,
                    title_name: title,
                    key: config.key,
                    content: {},
                    index: index,
                    isPlaceholder: false,
                  };
                }

                config.filterArray.forEach((field) => {
                  if (item[field]?.length) {
                    groupedDataMap[title].content[field] = Array.isArray(
                      item[field],
                    )
                      ? item[field].join("\n\n")
                      : item[field];
                  }
                });
              });

              const carouselData = Object.values(groupedDataMap);

              // Append grey placeholders if less than 3
              const placeholderCount = Math.max(0, 3 - carouselData.length);

              for (let i = 0; i < placeholderCount; i++) {
                carouselData.push({
                  key: `${config.key}-placeholder-${i}`,
                  isPlaceholder: true,
                });
              }

              return (
                <div key={config.key} className="col-md-12 main-card-block">
                  <label>{config.title}</label>
                  <div className="card bg-transparent">
                    <Carousel
                      value={carouselData}
                      numVisible={3}
                      numScroll={1}
                      itemTemplate={(data) =>
                        earlyWarningIndicator(
                          config.key,
                          data,
                          config.title,
                          earlyWarningIndicators,
                          data.isPlaceholder,
                        )
                      }
                    />
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "74vh", backgroundColor: "#F0F2FC" }}
          >
            <div
              className="text-center"
              style={{ maxWidth: "664px", padding: "0 48px" }}
            >
              <img
                src={exportimages?.EWI_not_found}
                alt="Not Found"
                className="img-fluid mb-4"
                style={{ maxHeight: "200px" }}
              />
              <h1 className="NoEWIContent">
                We're currently computing the optimal Early Warning Indicators
                and strategies for you. This process typically takes about one
                working day. Once the analysis is complete, you'll receive an
                email notification. In the meantime, feel free to check back
                here later to view the results. Thank you for your patience!
              </h1>
            </div>
          </div>
        )}
      </div>

      <div className="card flex justify-content-center">
        <Sidebar
          visible={visibleRight}
          position="right"
          onHide={() => setVisibleRight(false)}
          className="insights-detail-view-card"
          header={customHeader}
        >
          <div
            class="d-flex justify-content-start align-items-center"
            style={{ margin: " 1.846rem 0" }}
          >
            <div>
              <div className="insights-card-img">
                <img
                  src={
                    selectedCardData?.cardImage || exportimages?.EWI_Default_img
                  }
                  alt="insights_icon_1"
                />
              </div>
            </div>
            <label className="insights-card-label">
              {/* {selectedCardData?.cardHeader} */}{" "}
              {parse(String(selectedCardData?.cardHeader || ""))}
            </label>
          </div>
          {selectedCardData &&
            selectedCardData?.data.map(
              (desc, index) =>
                desc.content && (
                  <>
                    <div
                      className={
                        selectedCardData?.key?.toLowerCase() ===
                          "early_warning_indicators"
                          ? "insights-card-details bg-insights-card"
                          : "insights-card-details bg-strategy-card"
                      }
                    >
                      <div
                        className={
                          desc.label === "Recommendation"
                            ? "bg-blue-label-block d-flex justify-content-start align-items-center"
                            : "d-flex justify-content-start align-items-center"
                        }
                        style={{ marginBottom: "1.231rem" }}
                      >
                        <img
                          src={desc.img}
                          alt="insights_icon_2"
                          style={{ marginRight: "1.077rem" }}
                        />
                        <label className="insights-card-label">
                          {desc.label}
                        </label>
                      </div>
                      <div className="insights-card-details-desc">
                        <ul>
                          {String(desc.content)
                            .split("\n\n")
                            .map((line, index) => {
                              const trimmed = line.trim();
                              const isBullet = trimmed.startsWith("- ");
                              const content = isBullet
                                ? trimmed.slice(1).trim()
                                : trimmed;

                              const linked = ewiFormating(content);

                              return (
                                <li
                                  key={index}
                                  style={{
                                    listStyleType: isBullet ? "disc" : "none",
                                    marginLeft: isBullet ? "20px" : "0",
                                  }}
                                >
                                  {linked}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </>
                ),
            )}
        </Sidebar>
      </div>

      <div
        style={{
          display:
            hasSubscription(PRIVILEGES.CHATBOT) &&
              earlyWarningIndicators?.length > 0
              ? "block"
              : "none",
        }}
      >
        <Chatbot />
      </div>

      <ImageAndDataPopUp
        show={insightsModal}
        onHide={() => setInsightsModal(false)}
        modalData={insightsAndStrategyData}
      />

      <ImageAndDataPopUp
        show={autopilotProfitModal}
        onHide={() => setAutopilotProfitModal(false)}
        modalData={UpgradeToAutopilotProfit}
      />
    </div>
  );
};

export default InsightsAndRecommendation;
